import { ChartBlock } from "@/shared/ui/chart-block"
import { selectDailyStatistics } from "../../model";
import { useAppSelector } from "@/shared/lib/redux";
import { ChartData, ChartOptions } from "chart.js";
import { useMemo } from "react";
import { ru } from "date-fns/locale";

export const DailyRevenue = () => {
    const dailyStatistics = useAppSelector(selectDailyStatistics)

    const data: ChartData<"line"> = useMemo(() => {
        return {
            labels: dailyStatistics.map(i => i.date),
            datasets: [
                {
                    label: 'Сумма транзакций',
                    fill: true,
                    borderColor: 'rgba(5, 205, 153, 0.8)',
                    borderWidth: 2,
                    backgroundColor: function (ctx) {
                        const gradient = ctx.chart.ctx.createLinearGradient(0, 0, 0, 400);
                        gradient.addColorStop(0.01, 'rgb(5, 205, 153,0.6)');
                        gradient.addColorStop(0.7, 'rgb(5, 205, 153,0.1)');
                        return gradient
                    },
                    cubicInterpolationMode: 'monotone',
                    tension: 0.3,
                    data: dailyStatistics.map(i => i.total)
                },
                {
                    label: 'Сумма бонусных скидок',
                    fill: true,
                    borderColor: 'rgba(0, 0, 0, 0.8)',
                    borderWidth: 2,
                    backgroundColor: function (ctx) {
                        const gradient = ctx.chart.ctx.createLinearGradient(0, 0, 0, 400);
                        gradient.addColorStop(0.3, 'rgb(0,0,0,0.5)');
                        gradient.addColorStop(0.5, 'rgb(0,0,0,0.3)');
                        gradient.addColorStop(0.9, 'rgb(0,0,0,0.05)');
                        return gradient
                    },
                    cubicInterpolationMode: 'monotone',
                    tension: 0.3,
                    data: dailyStatistics.map(i => i.bonusTotal)
                },

            ]
        }
    }, [dailyStatistics])

        const options: ChartOptions<"line"> = {
            scales: {
                y: {
                    ticks: {
                        maxTicksLimit: 10
                    },
                    border: {
                        dash: [8, 4],
                        color: 'rgba(0, 0, 0, 0)'
                    },
                },
                x: {
                    type: 'time', 
                    time: {
                        unit: 'week',
                        round: 'day',
                        tooltipFormat: 'LLL d, yyyy'
                    },
                    adapters: {
                        date: {
                            locale: ru
                        }
                    },
                    grid: {
                        drawOnChartArea: false
                    },
                    border: {
                        color: 'rgba(0, 0, 0, 0)'
                    }
                },
            },
        }
    

    return (
        <ChartBlock type="line" chartClass="min-h-[350px] screen:min-h-[450px] h-full" title="Выручка за день" data={data} options={options} />
    )
}